import { render, staticRenderFns } from "./logistics-inform.vue?vue&type=template&id=36beaf61&scoped=true&"
import script from "./logistics-inform.vue?vue&type=script&lang=js&"
export * from "./logistics-inform.vue?vue&type=script&lang=js&"
import style0 from "./logistics-inform.vue?vue&type=style&index=0&id=36beaf61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36beaf61",
  null
  
)

export default component.exports